<template>
    <div class="container" style="margin-top: 100px;">
        <h5>Scheduled Interviews</h5>
        <!-- <div class="d-flex align-items-center">
            <div class="col-6 d-flex justify-content-between">
                <b-input v-model="search" placeholder="Search interviews"></b-input>
                <button class="btn btn-primary ml-3" @click="loadInterviews()">Search</button>
            </div>
        </div> -->
        <div class="template row mt-5" v-if="interviews.length">
           <div class="col-12 bg-white">
                <table class="table table-striped table-responsive" style="white-space: nowrap" v-if="interviews.length > 0">
                    <thead>
                        <tr>
                            <th>Job id</th>
                            <th>Designation</th>
                            <th>Candidate name</th>
                            <th>Candidate email</th>
                            <th>Date</th>
                            <th>Start time</th>
                            <th>End time</th>
                            <th>Join link</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="interview in interviews" :key="interview.room_id" :class="checkDate(interview.interview_time_from)">
                            <td>{{interview.job_id}}</td>
                            <td>{{interview.job_designation}}</td>
                            <td>{{interview.candidate_name}}</td>
                            <td>{{interview.candidate_email}}</td>
                            <td>{{interview.interview_date}}</td>
                            <td>{{getTime(interview.interview_time_from)}}</td>
                            <td>{{getTime(interview.interview_time_to)}}</td>
                            <td><a v-if="checkDate(interview.interview_time_from) == 'active'" :href="interview.interview_link" class="btn active" style="text-decoration:none;">Join</a>
                            <span v-else class="btn" :class="checkDate(interview.interview_time_from)" v-b-tooltip.hover :title="getHelpText(interview.interview_time_from)">{{checkDate(interview.interview_time_from)}}</span></td>
                        </tr>
                    </tbody>
                </table>
                <div v-if="interviews.length">
                    <div class="col pl-6" >                                                      
                        showing results <span>{{ (page-1)*25 + 1 }}</span> - <span>{{ total > (page-1)*25 + 25  ? (page-1)*25 + 25 : total}}</span> of <span>{{total}}</span>
                    </div>
                    <div class="col pt-0">
                        <v-pagination
                        v-model="page"
                        :length="length"
                        class="float-left"
                        @input="handlePageChange"
                        ></v-pagination>
                    </div>
                </div>
                <div v-else>
                    <b-card>No interviews found</b-card>
                </div>
           </div>
       </div>
       <div v-else>
        <b-card class="card my-5">
            <p>No scheduled interviews</p>
            <p>You can schedule interviews from Dashboard->Jobresponses</p>
        </b-card>
       </div>
       
    </div>
</template>

<script>

export default {
    name: 'manage_interviews',
    beforeMount() {
        if(this.$cookies.get("hire-employer")) this.token = this.$cookies.get("hire-employer").token;
       
        if(!this.token){
            this.$router.push({
            name: 'rec_login',
            params: { redirect_to: '/recruit/scheduled-interviews'}
            });
        } else {
            this.loadInterviews();
        }
    },
    data(){
        return {
            can_post: 0,
            token: null,
            interviews: [],
            length: 0,
            page:1,
            offset: 0,
            limit: 25,
            total: 0,
            params:'',
            search: ''
        }
    },
    methods: {
       
        handlePageChange(value) {
            this.page = value;
            this.offset = this.limit * (this.page - 1);
            this.loadInterviews()
        },
        loadInterviews: function(){
            this.params = '';
            // let params = '';
            this.params += '?offset='+ this.offset;
            if(this.search) this.params += '&search='+ this.search;
            new this.$apiAction().scheduledInterviews(this.token).then((res) => {
                if(res.meta.success) {
                    this.interviews = res.data;
                    this.limit = res.meta.limit;
                    this.offset = res.meta.offset;
                    this.total = res.meta.total;
                    this.length = Math.ceil(res.meta.total/res.meta.limit);
                }
            }).catch((err) => {
                console.log(err)
            });
        },
        checkDate(ts) {
            let exp_ts = ts + 1800;
            let current_time = new Date().getTime()/1000
            if(current_time < ts) return 'upcoming';
            else if(ts < current_time && current_time< exp_ts) return 'active';
            else if(current_time > exp_ts) return 'expired';
        },
        getHelpText(ts) {
            let exp_ts = ts + 1800;
            let current_time = new Date().getTime()/1000
            if(current_time < ts) return 'Interview not started yet, retry at the scheduled time';
            else if(current_time > exp_ts) return 'Interview link has been expired';
        },
        getTime(ts) {
            var timestamp = ts * 1000;
            var date = new Date(timestamp);
            return date.toLocaleTimeString();
        },
    }
    
}
</script>
<style>

.truncate-words{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.btn.expired {
    font-size: 0.75rem;
    color: white;
    background-color: #7cafcf ;
    text-transform: capitalize;
}
.btn.active, .btn.upcoming {
    color: white;
    font-size: 0.75rem;
    background-color: green;
    text-transform: capitalize;
}
.expired{
    color: #8f8f8f
}
</style>